/* eslint-disable no-param-reassign */

import md5 from '@common/sdk/md5'
import axios from 'axios'
import Store from 'store'

// 确定域名
const hostStg = 'https://test-stg1.zhi-niao.com'
const hostPrd = 'https://www.zhi-niao.com'

let zhiniaoHost = hostPrd
let loginTimer: any = null
const isDev = window.location.host.indexOf('gq-api.zhi-niao.com') > -1 ||
  window.location.host.indexOf('gq-h5.zhi-niao.com') > -1 ||
  window.location.host.indexOf('localhost') > -1 ||
  window.location.host.indexOf('test') > -1
  // window.location.host.indexOf('gacmotor') > -1
  // window.sessionStorage.getItem('pro2test') // 当存在pro2test时切换直播环境为saas

if (isDev) {
  zhiniaoHost = hostStg
}


export const addZhiniaoPrefix = (url: any) => {
  if (url.indexOf('http') === 0) {
    return url
  }
  if (url.indexOf('/') === 0) {
    return `${zhiniaoHost}${url}`
  }
  return `${zhiniaoHost}/${url}`
}

export const getZhiniaoPrefix = () => zhiniaoHost

export const addZhiniaoPrefixForImage = (url: any, type: any) => {
  if (url) {
    if (url.indexOf('http') > -1) {
      return url
    }
    if (type !== 1) {
      return addZhiniaoPrefix(`/learn/${url}`)
    }
  }
  return ''
}

// 静默登录e祺学
const loginZhiniao = (emplId = '', email = '') => {
  if (!emplId || !email) {
    console.log('静默登录失败：参数错误', { emplId, email })
    return
  }
  if (loginTimer) {
    clearTimeout(loginTimer)
  }
  console.log('走这里了')

  const liveUserInfo = Store.get('liveUserInfo') || {}
  if (
    liveUserInfo.sid &&
    liveUserInfo.time < Date.now() &&
    liveUserInfo.emplId === emplId
  ) {
    console.log('走这里了1')
    return
  }
  console.log('走这里了2')
  const url = addZhiniaoPrefix('/learn/app/clientapi/user/h5plugin.do')

  let pluginId = '7E70EF8E15444DA9A0DA3A8745A09114'
  let tokenSlat = 'EC5076B71917B773E053A438210AE725'

  if (isDev) {
    pluginId = '0DDBF673323242498CFE779F191A21FB'
    tokenSlat = 'E770DDD836373C97E053B901451E419B'
  }
  const time = Date.now().toString(16)

  const str = `${tokenSlat}?pluginId=${pluginId}&pluginType=99&emplId=${emplId}&time=${time}&email=${email}`
  const token = md5(str)
    .toString()
    .toUpperCase()

  // 参数顺序要一致
  const finalUrl = `${url}?pluginId=${pluginId}&pluginType=99&emplId=${emplId}&time=${time}&email=${email}&token=${token}`
  axios
    .get(finalUrl)
    .then(res => {
      const { code, sid, userId } = res.data || {}
      if (+code === 200) {
        Store.set('liveUserInfo', {
          sid,
          userId,
          time: Date.now() + 3600 * 1000,
          emplId,
        })
        return
      }
      Store.remove('liveUserInfo')
    })
    .catch(err => {
      Store.remove('liveUserInfo')
    })

  // 一个小时调一次登录接口，防止登录信息失效
  loginTimer = setTimeout(() => {
    loginZhiniao(emplId, email)
  }, 1000 * 60 * 60)
}

const loginZhiniaoSilent = (emplId = '', email = '') => {
  loginZhiniao(emplId, email)
}

export default loginZhiniaoSilent
